/**
 * The chord panel type and the settings it draws from.
 */

const chord = {
  names: [
    {
      id: 'chord',
      label: 'Chord',
      phrase: 'a chord diagram',
      guide: 'chord.md',
      advanced: true,
      toolSummary: 'which pairs exchange volume with each other and which way each exchange leans, one row per direction with its own already-aggregated total, capped at 24',
      promptSummary: 'which pairs exchange volume with each other, as points around a circle joined by ribbons whose thickness is the amount that moved, one row per direction with its own already-aggregated total, up to 24; a one-way journey through several steps is a sankey instead',
      /* The diagram is a circle, so it wants a box wider than it is tall rather than a shape derived
         from the rows: room for the labels sits beside the ring. The type asks for that shape once
         and stays freely resizable after. */
      creationLayout: { w: 6, h: 9 }
    }
  ],
  block: 'chord',
  /* Chord. Reads the same three columns a sankey does, and means the same thing by them: the query
     already returns one row per flow, and this block identifies the two ends of the ribbon and the
     amount that moved along it. There is no field for the point order or the ribbon thickness: the
     order is the rows' own, and the thickness is geometry. */
  fields: {
    sourceKey: { kind: 'string', required: true, hint: 'a flow needs both of its ends and an amount', label: 'Flow from' },
    targetKey: { kind: 'string', required: true, hint: 'a flow needs both of its ends and an amount', label: 'Flow to' },
    valueKey: { kind: 'string', required: true, hint: 'a flow needs both of its ends and an amount', label: 'Amount' },
    showLegend: { kind: 'boolean', default: true, label: 'Show legend' }
  },
  editorHint: 'One row is one flow: where it came from, where it ended up, and the amount that moved. The panel adds nothing up, so group each pair once in SQL, and keep the result to the flows that matter. The way back is its own row, with the two columns swapped.',
  stateSummary: ({ block }) => (block.sourceKey && block.targetKey && block.valueKey ? `chord: ${block.sourceKey} × ${block.targetKey} × ${block.valueKey}${block.showLegend === false ? ' · legend hidden' : ''}` : ''),
  toolSchema: {
    type: ['object', 'null'],
    additionalProperties: false,
    required: ['sourceKey', 'targetKey', 'valueKey'],
    description: 'Chord mapping (displayType "chord"): ONE ROW IS ONE FLOW between two labelled points, and its value is ALREADY AGGREGATED, so GROUP BY the pair in the source SQL and never send raw records. The same label is the same point wherever it appears, in either column. Unlike a sankey, a pair may flow BOTH ways: emit the way back as its own row with the two columns swapped, and both ribbons are drawn. There are no layers, so a chain of hops (A to B to C) draws as unrelated ribbons and is a sankey instead. A flow whose two ends are the same label has no pair to join and is counted below the diagram. Capped at 24 flows, with anything not drawn counted below the diagram. Read immutable/analytics/panel-types/chord.md before configuring one.',
    properties: {
      sourceKey: { type: 'string', description: 'Column naming where the flow comes from. Dot paths work.' },
      targetKey: { type: 'string', description: 'Column naming where the flow ends up. Dot paths work.' },
      valueKey: {
        type: 'string',
        description: 'Column holding the positive numeric amount that moved along this flow. Dot paths work. An empty, non-numeric, zero, or negative amount has no ribbon to draw and is counted as not shown.'
      },
      showLegend: { type: 'boolean', description: 'Whether the legend naming each point appears under the diagram. Defaults true. Set false when the user asks for the legend gone; each point keeps the name written around its arc.' }
    }
  }
};

export default chord;
